/**
 * Navigation JavaScript
 * Handles mobile menu toggle and accessibility features
 */



(function () {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initNavigation);
    } else {
        initNavigation();
    }

    function initNavigation() {
        // Mega menu navigation
        megamenuNavigation();

        // Mobile menu toggle
        initMobileMenu();

        // Keyboard navigation for dropdowns
        initDropdownKeyboardNav();

        // Handle focus trap in mobile menu
        initFocusTrap();
    }

    function megamenuNavigation() {

        const toggleMenuItems = document.querySelectorAll('.main-navigation__menu-item.has-children');

        // Attach listeners to EACH toggle item
        toggleMenuItems.forEach(function(menuItem) {
            // Click listener
            menuItem.addEventListener('click', function(e) {
                const isMobileOrTablet = window.innerWidth < 1024;

                // On mobile/tablet, only the icon should open the menu — let the link navigate normally
                if (isMobileOrTablet && !e.target.closest('.main-navigation__link-icon')) {
                    return;
                }

                e.preventDefault();

                const parentContainer = menuItem.closest('.umb-block-grid__layout-item');
                if (!parentContainer) {
                    console.error('Mega menu parent container not found.');
                    return; 
                }

                const subMenu = parentContainer.querySelector('.mega-menu');
                if (!subMenu) {
                    console.error('Mega menu element not found within the container.');
                    return;
                }
                
                const isExpanded = menuItem.getAttribute('aria-expanded') === 'true';

                const currentlyOpenItem = document.querySelector('.main-navigation__menu-item[aria-expanded="true"]');
                if (currentlyOpenItem && currentlyOpenItem !== menuItem) {
                    currentlyOpenItem.setAttribute('aria-expanded', 'false');
                    
                    const otherParentContainer = currentlyOpenItem.closest('.umb-block-grid__layout-item');
                    if (otherParentContainer) {
                        const otherSubMenu = otherParentContainer.querySelector('.mega-menu');
                        if (otherSubMenu) {
                            otherSubMenu.classList.remove('mega-menu--open');
                        }
                    }
                }
                // Toggle the current item
                menuItem.setAttribute('aria-expanded', !isExpanded);
                subMenu.classList.toggle('mega-menu--open');
            });

            // Keydown listener
            menuItem.addEventListener('keydown', function(e) {
                // Enter or Space should behave exactly like a click
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    menuItem.click(); // Trigger the click event to reuse its logic
                }

                // Arrow down should open the menu and focus the first item
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // If the menu is closed, open it by triggering a click
                    if (menuItem.getAttribute('aria-expanded') === 'false') {
                        menuItem.click();
                    }
                    // Focus the first link inside the submenu
                    const firstSubItem = subMenu.querySelector('a, button');
                    if (firstSubItem) {
                        firstSubItem.focus();
                    }
                }
            });
        });

        // Close menus when clicking outside
        document.addEventListener('click', function(e) {
            const openMenuItem = document.querySelector('.main-navigation__menu-item[aria-expanded="true"]');
            
            if (!openMenuItem) {
                return;
            }

            const parentContainer = openMenuItem.closest('.umb-block-grid__layout-item');
            if (!parentContainer) {
                return;
            }
            const openSubMenu = parentContainer.querySelector('.mega-menu');
            if (!openSubMenu) {
                return;
            }

            const isClickInsideMenu = openMenuItem.contains(e.target);
            const isClickInsideSubMenu = openSubMenu.contains(e.target);
            
            if (isClickInsideMenu || isClickInsideSubMenu) {
                return;
            }

            openMenuItem.setAttribute('aria-expanded', 'false');
            openSubMenu.classList.remove('mega-menu--open');
        });

        // Close menus with the 'ESCAPE' key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                const openMenuItem = document.querySelector('.main-navigation__menu-item[aria-expanded="true"]');
                if (openMenuItem) {
                    openMenuItem.setAttribute('aria-expanded', 'false');
                    openMenuItem.nextElementSibling.classList.remove('mega-menu--open');
                    openMenuItem.focus(); // Return focus to the toggle button
                }
            }
        });

    }

    /**
     * Initialize mobile menu toggle functionality
     */
    function initMobileMenu() {
        const toggleButton = document.querySelector('.nav-toggle');
        const mobileMenu = document.querySelector('.mobile-menu');
        const body = document.body;
        const sidebarMenu = document.querySelector('.sidebar__left');

        if (!toggleButton || !mobileMenu) {
            return;
        }

        // Toggle menu on button click
        toggleButton.addEventListener('click', function () {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            mobileMenu.classList.toggle('is-open');
            body.classList.toggle('overflow-hidden', !isExpanded);
            document.querySelector('html').classList.toggle('overflow-hidden', !isExpanded);
            if (sidebarMenu) {
                sidebarMenu.classList.toggle('hide');
            }

            // Manage focus
            if (!isExpanded) {
                // Menu is opening - focus first link
                const firstLink = mobileMenu.querySelector('.nav-menu-link');
                if (firstLink) {
                    setTimeout(() => firstLink.focus(), 100);
                }
            }
        });

        // Close menu when clicking outside
        document.addEventListener('click', function (event) {
            if (!event.target.closest('.header-nav') &&
                !event.target.closest('.nav-toggle')) {
                closeMobileMenu();
            }
        });

        // Close menu on escape key
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeMobileMenu();
                toggleButton.focus();
            }
        });

        // Handle submenu toggles on mobile
        const hasSubmenuItems = document.querySelectorAll('.nav-menu-item.has-submenu');
        hasSubmenuItems.forEach(function (item) {
            const link = item.querySelector('.nav-menu-link');

            link.addEventListener('click', function (event) {
                // Only prevent default on mobile
                if (window.innerWidth < 768) {
                    event.preventDefault();
                    item.classList.toggle('is-open');
                }
            });
        });

        // Close mobile menu on resize to desktop
        window.addEventListener('resize', function () {
            if (window.innerWidth >= 768) {
                closeMobileMenu();
            }
        });

        // Close dropdowns when window is resized to desktop
        window.addEventListener('resize', function() {
            if (window.innerWidth >= 1024) {
                document.querySelectorAll('.topMenuItem[aria-expanded="true"]').forEach(function(item) {
                    item.setAttribute('aria-expanded', 'false');
                });
            }
        });
    }

    /**
     * Close mobile menu
     */
    function closeMobileMenu() {
        const toggleButton = document.querySelector('.nav-toggle');
        const navMenu = document.querySelector('.nav-menu');

        if (toggleButton && navMenu) {
            toggleButton.setAttribute('aria-expanded', 'false');
            toggleButton.textContent = 'Menu';
            navMenu.classList.remove('is-open');
        }

        // Close all open submenus
        document.querySelectorAll('.nav-menu-item.is-open').forEach(function (item) {
            item.classList.remove('is-open');
        });
    }

    /**
     * Initialize keyboard navigation for dropdown menus
     */
    function initDropdownKeyboardNav() {
        const menuItems = document.querySelectorAll('.nav-menu-item.has-submenu');

        menuItems.forEach(function (item) {
            const link = item.querySelector('.nav-menu-link');
            const submenu = item.querySelector('.nav-submenu');

            if (!link || !submenu) {
                return;
            }

            // Handle keyboard navigation
            link.addEventListener('keydown', function (event) {
                // Desktop only
                if (window.innerWidth < 768) {
                    return;
                }

                switch (event.key) {
                    case 'ArrowDown':
                        event.preventDefault();
                        // Focus first submenu item
                        const firstSubmenuLink = submenu.querySelector('.nav-submenu-link');
                        if (firstSubmenuLink) {
                            firstSubmenuLink.focus();
                        }
                        break;

                    case 'Escape':
                        event.preventDefault();
                        link.focus();
                        break;
                }
            });

            // Handle submenu keyboard navigation
            const submenuLinks = submenu.querySelectorAll('.nav-submenu-link');
            submenuLinks.forEach(function (submenuLink, index) {
                submenuLink.addEventListener('keydown', function (event) {
                    switch (event.key) {
                        case 'ArrowDown':
                            event.preventDefault();
                            // Focus next submenu item
                            if (index < submenuLinks.length - 1) {
                                submenuLinks[index + 1].focus();
                            }
                            break;

                        case 'ArrowUp':
                            event.preventDefault();
                            // Focus previous submenu item or parent
                            if (index > 0) {
                                submenuLinks[index - 1].focus();
                            } else {
                                link.focus();
                            }
                            break;

                        case 'Escape':
                            event.preventDefault();
                            link.focus();
                            break;
                    }
                });
            });
        });
    }

    /**
     * Initialize focus trap for mobile menu
     */
    function initFocusTrap() {
        const navMenu = document.querySelector('.nav-menu');
        const toggleButton = document.querySelector('.nav-toggle');

        if (!navMenu || !toggleButton) {
            return;
        }

        navMenu.addEventListener('keydown', function (event) {
            // Only trap focus when mobile menu is open
            if (!navMenu.classList.contains('is-open')) {
                return;
            }

            if (event.key === 'Tab') {
                const focusableElements = navMenu.querySelectorAll(
                    'a[href], button:not([disabled])'
                );
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                // Shift + Tab on first element - go to close button
                if (event.shiftKey && document.activeElement === firstElement) {
                    event.preventDefault();
                    toggleButton.focus();
                }
                // Tab on last element - go to close button
                else if (!event.shiftKey && document.activeElement === lastElement) {
                    event.preventDefault();
                    toggleButton.focus();
                }
            }
        });
    }

    /**
     * Highlight current page in navigation
     */
    function highlightCurrentPage() {
        const currentPath = window.location.pathname;
        const navLinks = document.querySelectorAll('.nav-menu-link, .nav-submenu-link');

        navLinks.forEach(function (link) {
            const linkPath = new URL(link.href).pathname;

            if (linkPath === currentPath) {
                link.classList.add('active');
                link.setAttribute('aria-current', 'page');
            }
        });
    }

    // Highlight current page on load
    highlightCurrentPage();

})();
